import * as React from "react";
const SvgFilters = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "currentColor"
}, d: "M6.33333 10V8.33333H9.66667V10H6.33333ZM3 5.83333V4.16667H13V5.83333H3ZM0.5 1.66667V0H15.5V1.66667H0.5Z", fill: "currentColor" }));
export default SvgFilters;
